import { DevicePromiseManager } from "../devicePromiseManager";

class Session {
    static async GetJWTToken() {
        let jwtToken;

        try {
            const response = await DevicePromiseManager.call("getCurrentSession");

            if (response.ok === true) {
                jwtToken = response.idToken.jwtToken;
            }
        } catch (error) {
            return undefined;  
        }

        return jwtToken;
    }

    async IsLoggedIn() {
        return new Promise(async (resolve, reject) => {
            try {
                const jwtToken = await Session.GetJWTToken();

                if (jwtToken === undefined) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            } catch (error) {
                reject(error);
            }
        })
    }
}

export default Session;